import Main from "@/views/Main.vue";

const requireContext = require("require-context");

// 不作为Main组件的子页面展示的页面单独写，如下
/* export const loginRouter = {
  path: "/login",
  name: "login",
  meta: {
    title: "Login - 登录"
  },
  component: () => import("@/views/login.vue")
}; */

export const page404 = {
  path: "/*",
  name: "error-404",
  meta: {
    title: "404-页面不存在",
  },
  component: () => import("@/views/error-page/404.vue"),
};

export const page403 = {
  path: "/403",
  meta: {
    title: "403-权限不足",
  },
  name: "error-403",
  component: () => import("@//views/error-page/403.vue"),
};

export const page500 = {
  path: "/500",
  meta: {
    title: "500-服务端错误",
  },
  name: "error-500",
  component: () => import("@/views/error-page/500.vue"),
};

export const locking = {
  path: "/locking",
  name: "locking",
  component: () =>
    import("@/views/main-components/lockscreen/components/locking-page.vue"),
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: "/",
  name: "otherRouter",
  redirect: "/home",
  component: Main,
  children: [],
};

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里

let menuRouter = [
  {
    path: "/index",
    icon: "ios-home",
    color: "#5AB0FF",
    name: "scet-index",
    title: "首页",
    component: Main,
    fId: 1,
    meta: {
      title: "首页",
    },
    children: [
      {
        path: "home",
        icon: "ios-home",
        title: "首页",
        routeId: "1-0",
        meta: {
          title: "首页",
        },
        name: "home_index",
        component: () => import("@/views/Guanglutong/home.vue"),
      },
    ],
  },
];
let computedRouter = [
  {
    path: "/",
    icon: "ios-home",
    color: "#5AB0FF",
    name: "scet-index",
    title: "首页",
    component: Main,
    fId: 1,
    meta: {
      title: "首页",
    },
    children: [
      {
        path: "home",
        icon: "ios-home",
        title: "首页",
        meta: {
          title: "首页",
        },
        name: "首页",
        component: () => import("@/views/Guanglutong/home.vue"),
      },
      {
        path: "customer",
        icon: "ios-home",
        title: "客户管理",
        meta: {
          title: "客户管理",
        },
        name: "客户管理",
        component: () => import("@/views/Guanglutong/CustomerManagement.vue"),
      },
      {
        path: "order",
        icon: "ios-home",
        title: "运单管理",
        meta: {
          title: "运单管理",
        },
        name: "运单管理",
        component: () => import("@/views/Guanglutong/OrderManagement.vue"),
      },
      {
        path: "crmDetail",
        icon: "ios-home",
        title: "CRM详情",
        meta: {
          title: "CRM详情",
        },
        name: "CRM详情",
        component: () => import("@/views/Guanglutong/CRMDetails.vue"),
      },
      {
        path: "crmSum",
        icon: "ios-home",
        title: "CRM统计",
        meta: {
          title: "CRM统计",
        },
        name: "CRM统计",
        component: () => import("@/views/Guanglutong/CRMSum.vue"),
      },
      {
        path: "profit",
        icon: "ios-home",
        title: "利润报表",
        meta: {
          title: "利润报表",
        },
        name: "利润报表",
        component: () => import("@/views/Guanglutong/ProfitReport.vue"),
      },
      {
        path: "royalty",
        icon: "ios-home",
        title: "提成明细",
        meta: {
          title: "提成明细",
        },
        name: "提成明细",
        component: () => import("@/views/Guanglutong/RoyaltyDetails.vue"),
      },
      {
        path: "cost",
        icon: "ios-home",
        title: "公司成本表",
        meta: {
          title: "公司成本表",
        },
        name: "公司成本表",
        component: () => import("@/views/Guanglutong/CompanyCost.vue"),
      },
      {
        path: "user",
        icon: "ios-home",
        title: "用户管理",
        meta: {
          title: "用户管理",
        },
        name: "用户管理",
        component: () => import("@/views/Guanglutong/UserManagement.vue"),
      },
    ],
  },
];

// 获取权限菜单
function getUserMenu(userArray) {
  console.log(userArray);
}
export const appRouter = computedRouter;

export const originMenuRoutes = JSON.parse(JSON.stringify(menuRouter));

export const menuRoutes = menuRouter;

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  // loginRouter,
  locking,
  ...appRouter,
  // otherRouter,
  page500,
  page403,
  // page404
];
